module.exports = {

    surveypath: 'https://jlnk.at', 
  //  surveypath: 'https://api2-demo.joobster.at/survey', //demo
    api_base_path: '/admin',
    internalsurveypath: 'https://viewer2.joobster.at/survey'
   // internalsurveypath: 'https://survey.jlnk.at/survey', 
//    internalsurveypath: 'https://viewer2-demo.joobster.at/survey' //demo
	
}


// WEBPACK FOOTER //
// ./src/settings.js